import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CustomTable = ({ columns, data }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <TableContainer
      component={Paper}
      sx={{
        maxHeight: "calc(100vh - 200px)",
        overflowY: "auto",
        overflowX: "auto", // ✅ cho phép scroll ngang nếu bảng quá rộng
        border: "1px solid #ddd",
      }}
    >
      <Table
        stickyHeader
        sx={{
          minWidth: isMobile ? "100%" : "800px", // ✅ mobile full width, desktop thì đảm bảo không quá hẹp
        }}
      >
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
            {columns.map((column, index) => (
              <TableCell
                key={index}
                sx={{
                  fontWeight: "bold",
                  minWidth: column.minWidth || 120,
                  fontSize: isMobile ? "0.75rem" : "0.9rem",
                  padding: isMobile ? "6px" : "12px",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={rowIndex} hover>
              {columns.map((column, colIndex) => (
                <TableCell
                  key={colIndex}
                  sx={{
                    fontSize: isMobile ? "0.75rem" : "0.9rem",
                    padding: isMobile ? "6px" : "12px",
                  }}
                >
                  {column.customRender
                    ? column.customRender(row)
                    : row[column.field]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomTable;
